import { useState } from "react";

import { ButtonV4, FieldV4, SelectV4 } from "../common/ui";
import type { OptionType } from "react-lib/apps/HISV3/common/CommonInterface";
import type { InteractionAlert } from "../common/sequence/OrderSheetV4";

import { SEVERITY_TEXT } from "./ordersModelV4";

// Types
type ModalDrugInteractionV4Props = {
  // data
  alert: InteractionAlert;
  reasonOptions: OptionType[];
  // callback
  onResolve: (choice: "cancel" | "order", reason: string) => void;
};

/** แจ้งเตือนยาตีกัน / ยาที่มีผลกับผลแลป ก่อนเพิ่มยาเข้าใบคำสั่ง */
const ModalDrugInteractionV4 = (props: ModalDrugInteractionV4Props) => {
  const [reason, setReason] = useState("");

  const { alert } = props;

  // Handler
  const handleResolve = (choice: "cancel" | "order") => {
    setReason("");
    props.onResolve(choice, reason.trim());
  };

  // Render
  return (
    <div className="hv4-modal hv4-modal-alert">
      <section
        role="alertdialog"
        aria-modal="true"
        aria-label="แจ้งเตือนยาตีกัน"
        className="hv4-card hv4-modal-card hv4-ord-adr hv4-ord-di"
      >
        <h2 className="hv4-card-title hv4-ord-adr-title">⚠️ แจ้งเตือน: ยาตีกัน</h2>
        <div className="hv4-ord-di-list">
          {alert.drugs.map((group) => (
            <div key={group.id} className="hv4-ord-di-item">
              <div className="hv4-ord-di-names">{group.names.join(" + ")}</div>
              <p>ความรุนแรง: {SEVERITY_TEXT[group.severity ?? 5]}</p>
              {!!group.affectSummary && <p>ผลของการเกิดอันตรกิริยา: {group.affectSummary}</p>}
              {!!group.management && <p>การจัดการ: {group.management}</p>}
            </div>
          ))}
          {alert.labs.map((lab) => (
            <div key={lab.product} className="hv4-ord-di-item">
              <div className="hv4-ord-di-names">{lab.name}</div>
              {!!lab.summary && <p>{lab.summary}</p>}
              {!!lab.detail && <p>{lab.detail}</p>}
            </div>
          ))}
        </div>
        <FieldV4
          label="เหตุผลที่ยังต้องสั่ง (บังคับกรอก · บันทึกไว้ในใบคำสั่ง)"
          htmlFor="hv4_ord_di_reason"
        >
          <SelectV4
            id="hv4_ord_di_reason"
            search
            allowAdd
            placeholder="เลือกหรือพิมพ์เหตุผล"
            options={props.reasonOptions}
            value={reason}
            onChange={setReason}
          />
        </FieldV4>
        <div className="hv4-ord-adr-actions">
          <ButtonV4 variant="ghost" onClick={() => handleResolve("cancel")}>
            ยกเลิก · ไม่สั่ง
          </ButtonV4>
          <ButtonV4
            className="hv4-ord-adr-ok"
            disabled={!reason.trim()}
            onClick={() => handleResolve("order")}
          >
            ยืนยันสั่งต่อ
          </ButtonV4>
        </div>
      </section>
    </div>
  );
};

ModalDrugInteractionV4.displayName = "ModalDrugInteractionV4";

export default ModalDrugInteractionV4;
